import api from "./api";

export const getAvailableDisbursementBank = async () => {
  return api
    .get({
      endpoint: "/x/available_disbursements_banks",
      port: process.env.REACT_APP_PORT_PAYMENT
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
